import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'BalancesBanner.title',
    defaultMessage: 'Important note',
    description: 'title of banner about delayed balances',
  },
  description: {
    id: 'BalancesBanner.description',
    defaultMessage:
      'Final withdrawal balance might not include recent withdrawals or any withdrawals executed outside of Coinbase Commerce.',
    description: 'description of why balances may be inaccurate',
  },
});
